import { Component, Input, Output, EventEmitter } from '@angular/core';
import { COMMON_IMPORTS } from '../../global-misc/common-imports';

@Component({
  selector: 'app-form-submission-success',
  imports: [...COMMON_IMPORTS],
  template: `
    <div class="flex flex-column align-items-center justify-content-center p-6 text-center">
      <div class="border-circle bg-green-100 p-4 mb-4">
        <i class="pi pi-check text-green-600 text-6xl"></i>
      </div>
      
      <h2 class="text-2xl font-bold text-gray-800 mb-3">
        {{ title || 'Form Submitted Successfully!' }}
      </h2>
      
      <p class="text-lg text-gray-600 mb-4 max-w-30rem line-height-3">
        {{ message || 'Your form has been submitted successfully. You can now navigate away from this page or close this window.' }}
      </p>
      
      <div class="flex flex-wrap gap-3 justify-content-center" *ngIf="showActions">
        <button 
          type="button" 
          class="p-button p-button-outlined"
          (click)="onGoBack()"
          *ngIf="showBackButton">
          <i class="pi pi-arrow-left mr-2"></i>
          {{ backButtonText || 'Go Back' }}
        </button>
        
        <button 
          type="button" 
          class="p-button"
          (click)="onContinue()"
          *ngIf="showContinueButton">
          {{ continueButtonText || 'Continue' }}
          <i class="pi pi-arrow-right ml-2"></i>
        </button>
      </div>
      
      <div class="mt-4 text-sm text-gray-500" *ngIf="showNavigationHint">
        <i class="pi pi-info-circle mr-1"></i>
        You can safely navigate away from this page
      </div>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      min-height: 300px;
    }
    
    .border-circle {
      width: 120px;
      height: 120px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }
    
    .max-w-30rem {
      max-width: 30rem;
    }
    
    .line-height-3 {
      line-height: 1.5;
    }
  `]
})
export class FormSubmissionSuccessComponent {
  @Input() title?: string;
  @Input() message?: string;
  @Input() showActions = false;
  @Input() showBackButton = false;
  @Input() showContinueButton = false;
  @Input() backButtonText?: string;
  @Input() continueButtonText?: string;
  @Input() showNavigationHint = true;

  @Output() backClicked = new EventEmitter<void>();
  @Output() continueClicked = new EventEmitter<void>();

  onGoBack(): void {
    window.history.back();
  }

  onContinue(): void {
    // This can be overridden by parent components or handled via event emission
    // For now, we'll just close the window if it was opened in a popup
    if (window.opener) {
      window.close();
    }
  }
}
